import { assessmentTreatmentGoalsApi } from "./index";

export const manageGoalsApi = assessmentTreatmentGoalsApi.injectEndpoints({
  endpoints: (builder) => ({
    createGoal: builder.mutation({
      query: ({ assessmentId, data, clientType }) => ({
        url: `/${clientType}/assesment-goals/create/${assessmentId}`,
        method: 'POST',
        data,
      })
    }),
    updateGoal: builder.mutation({
      query: ({ goalId, data, clientType }) => ({
        url: `/${clientType}/assesment-goals/update/${goalId}`,
        method: 'PUT',
        data,
      })
    }),
    deleteGoal: builder.mutation({
      query: ({ goalId, clientType }) => ({
        url: `/${clientType}/assesment-goals/remove/${goalId}`,
        method: 'DELETE',
      })
    }),
  }),
});

export const {
  useCreateGoalMutation,
  useUpdateGoalMutation,
  useDeleteGoalMutation,
} = manageGoalsApi;